export enum COMPANY_LISTING_STATUS {
    PUBLIC = 'public',
    DELISTED = 'Delisted',
    DISSOLVED = 'Dissolved',
    PRIVATE = 'private',
    DELISTED_AND_DISSOLVED = 'Delisted and Dissolved',
    SPV = 'SPV',
    GOVERNMENT_BODY = 'Government Body',
}
